export default __webpack_public_path__ + "static/media/map.f06a2b3e.png";